import { isEmpty } from 'lodash';

import userStorage from 'utils/user/userStorage';

export const userSession = () => {
  const user = userStorage.getUser();
  const token = userStorage.getToken();
  if (!isEmpty(user) && token) {
    return user;
  }
  return null;
};

export const userSessionFullName = () => {
  return `${userSession()?.firstName} ${userSession()?.lastName}`;
};
